import { render, staticRenderFns } from "./HasElevator.vue?vue&type=template&id=06585312&"
import script from "./HasElevator.vue?vue&type=script&lang=ts&"
export * from "./HasElevator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports